import React, { useCallback } from 'react';
import { Box } from '@televet/kibble-ui/build/chakra';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { Text } from '@televet/kibble-ui/build/components/Text';
import StatusChangeSelect from '../Compose/StatusChangeSelect';
import { ISurveyGeneralSettings, useSurveySettingsContext } from 'pages/Survey/context/SurveySettingsContext';

interface IStatusChangeProps {
  handleChange: (field: keyof ISurveyGeneralSettings | 'sentStatusId', newValue: string) => void;
}

const StatusChange = ({ handleChange }: IStatusChangeProps): JSX.Element => {
  const {
    composeSettings: { sentStatusId },
  } = useSurveySettingsContext();

  const handleSentStatusChange = useCallback(
    (newValue: string) => {
      handleChange('sentStatusId', newValue);
    },
    [handleChange],
  );

  return (
    <Box className="settings__container" mt="32px">
      <Heading className="settings__header" size="md" mb={2}>
        {`Conversation Status Change (Optional)`}
      </Heading>
      <Text className="settings__description" variant="subtle" mb={4}>
        Automatically changes the conversation status after a survey is sent if specified
      </Text>
      <StatusChangeSelect includeLabel={false} selectedStatusId={sentStatusId} handleChange={handleSentStatusChange} />
    </Box>
  );
};

export default StatusChange;
